import * as React from 'react';

import {Button} from 'shells/button/button';
import {FlashBanner} from 'shells/flash-banner/flash-banner';

import type {ErrorDetails} from './helpers';

import styles from './render-error-banner.module.css';

type Props = {
    error: string;
    errorDetails: ErrorDetails | null | undefined;
};

export function RenderErrorBanner({error, errorDetails}: Props) {
    const [showFullStack, setShowFullStack] = React.useState<boolean>(false);

    const hasStackInfo = errorDetails && (errorDetails.stack || errorDetails.componentStack);

    return (
        <div className='mb-16'>
            <FlashBanner type='error' animate={false} hasBorder={true} leftAlignContent={true}>
                <div>
                    <div className='flex align-center gap-8 mb-8'>
                        <span className={styles.icon}>⚠️</span>
                        <span className='font-bold'>Email Render Error</span>
                    </div>
                    <pre className={styles.message}>
                        {errorDetails ? errorDetails.message : error}
                    </pre>
                    {hasStackInfo && (
                        <div className='mt-12'>
                            <Button
                                variant='text-primary'
                                onClick={() => setShowFullStack(!showFullStack)}
                            >
                                {showFullStack ? 'Hide Stack Traces' : 'Show Stack Traces'}
                            </Button>
                            {showFullStack && (
                                <div className='mt-12'>
                                    {errorDetails && errorDetails.stack && (
                                        <div className='mb-8'>
                                            <div className='font-bold mb-4'>Error Stack:</div>
                                            <pre className={styles.stackTrace}>
                                                {errorDetails.stack}
                                            </pre>
                                        </div>
                                    )}
                                    {errorDetails && errorDetails.componentStack && (
                                        <div>
                                            <div className='font-bold mb-4'>Component Stack:</div>
                                            <pre className={styles.stackTrace}>
                                                {errorDetails.componentStack}
                                            </pre>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </FlashBanner>
        </div>
    );
}
